
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip5 extends Vue {}
